
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexYerk4_ydDRF0Qu8HB6YWh8lxT6KTqjv6Of1hiBCJXM8Meta } from "/home/vsts/work/1/s/src/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93edXu0TGVGk18u00Drhd0M6wNocehLMjZt5_45A8JadgVQMeta } from "/home/vsts/work/1/s/src/pages/[...slug].vue?macro=true";
import { default as reviews_X3guKnElhvo1la_45ZOmygI7CRhUR17QoNM93ZzEBoKUMeta } from "/home/vsts/work/1/s/src/pages/products/reviews.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/src/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/vsts/work/1/s/src/pages/[...slug].vue")
  },
  {
    name: "products-reviews",
    path: "/products/reviews",
    component: () => import("/home/vsts/work/1/s/src/pages/products/reviews.vue")
  }
]